import { render, staticRenderFns } from "./WaterSoftener.vue?vue&type=template&id=242dbed3&scoped=true&"
import script from "./WaterSoftener.vue?vue&type=script&lang=js&"
export * from "./WaterSoftener.vue?vue&type=script&lang=js&"
import style0 from "./WaterSoftener.vue?vue&type=style&index=0&id=242dbed3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242dbed3",
  null
  
)

export default component.exports